import { createModalContext } from 'modules/campaigns/lib/contexts/createModalContext';

export enum ModalType {
  None = 'None',
  CreateGoalModal = 'CreateGoalModal',
  DashboardFiltersModal = 'DashboardFiltersModal',
}

/**
 * TODO: make these types stricter
 */
export type ModalProps = Record<string, any>;

export const { ModalContext, ModalProvider, useModalContext } = createModalContext<
  ModalType,
  ModalProps
>();
